// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuex from 'vuex'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
//引用富文本编辑器
import VueQuillEditor from 'vue-quill-editor'
 //引入富文本css
// require styles
import 'quill/dist/quill.core.css'
import { download } from '@/utils/request'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import Editor from "@/components/Editor"
//富文本编辑器添加实例
Vue.use(VueQuillEditor, /* { default global options } */)
Vue.use(ElementUI)
Vue.use(Vuex)
Vue.prototype.download = download

Vue.config.productionTip = false
Vue.component('Editor', Editor)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  beforeCreate(){
    Vue.prototype.$bus = this                            //$bus作为一个vm是拥有$on $emit的全局事件总线
  },
})



// WEBPACK FOOTER //
// ./src/main.js